VjsAdmin.Permissions = (function () {
    const $table = $('#permissions-table');
    let roleData = [];

    const init = function () {
        initData();
        new UserEvents();
    };

    const UserEvents = VjsAdmin.Controller.extend({
        events: {
            'click .permissionCheckbox': 'clickGrantRevoke',
            'click #popupEnableDisableAllPermissions': 'popupEnableDisableAllRoles',
            'click #enableAllPermissionsButton': 'clickEnableAll',
            'click #disableAllPermissionsButton': 'clickDisableAll',
            'click button[name="refresh"]': 'clickRefresh',
        },
        clickGrantRevoke(e) {
            if (e.currentTarget.checked) {
                grantOrRevokeSingle('grant', e);
            } else {
                grantOrRevokeSingle('revoke', e);
            }
        },
        popupEnableDisableAllRoles() {
            VjsUtility.Popup.init({
                title: 'Enable/Disable All Permissions by Role',
                templateUrl: '/assets/templates/user-management/permissions/enable-disable-all-permissions-component.html',
                bodyClasses: 'non-matched-users',
                data: roleData,
            });
        },
        clickEnableAll: () => {
            grantOrRevokeAll('grantAll');
        },
        clickDisableAll: () => {
            grantOrRevokeAll('revokeAll');
        },
        clickRefresh: () => {
            initData();
            $table.bootstrapTable('selectPage', $('#permissions-table').bootstrapTable('getOptions').pageNumber);
        },
    });

    const initData = () => {
        const req = new VjsUtility.Request();
        req.post(Slim.Router.pathFor('user_management.permissions.list.json'), {}).done((res) => {
            roleData = res.roles;
            const columns = [
                {
                    title: 'Permission (Sorted by most recent)',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sortName: 'permission_id',
                    sortOrder: 'desc',
                    formatter: (value) => `<span class="font-weight-bold text-sm">${value}</span>`,
                },
            ];
            Object.keys(roleData).forEach((d) => {
                columns.push({
                    title: roleData[d].name,
                    field: `${roleData[d].name.toLowerCase().replace(' ', '')}_role`,
                    align: 'left',
                    valign: 'middle',
                    formatter: (value, row) => {
                        let checked = '';
                        if ('permissions' in roleData[d]) {
                            if (row.permission_id in roleData[d].permissions) {
                                checked = 'checked';
                            }
                        }
                        return `<input class="permissionCheckbox" type="checkbox" data-permission-name="${row.name}" data-permission-id="${row.permission_id}" data-role-id="${roleData[d].role_id}" ${checked}>`;
                    },
                });
            });
            initTable(res.permissions, columns);
        });
    };

    const initTable = (data, columns) => {
        $table.bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#permissions-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No permission matching the search term <strong>\`${searchTerm}\`</strong>`;
            },
            data,
            columns,
            sidePagination: 'client',
            sortName: 'name',
            sortOrder: 'desc',
        });
    };

    const grantOrRevokeSingle = (route, e) => {
        e.preventDefault();
        const roleId = $(e.currentTarget).data('role-id');
        const permissionId = $(e.currentTarget).data('permission-id');
        const permissionName = $(e.currentTarget).data('permission-name');
        document.body.style.cursor = 'wait';
        $.ajax({
            url: Slim.Router.pathFor(`user_management.permissions.${route}`),
            type: 'POST',
            data: {
                role_id: roleId,
                permission_id: permissionId,
            },
            success() {
                if (route === 'grant') {
                    e.currentTarget.checked = !e.currentTarget.checked;
                    roleData[roleId].permissions = {
                        ...roleData[roleId].permissions,
                        [permissionId]: permissionName,
                    };
                } else if (route === 'revoke') {
                    e.currentTarget.checked = !e.currentTarget.checked;
                    delete roleData[roleId].permissions[permissionId];
                }
            },
            error(data) {
                let errorMessage = '';
                if (data.status < 400) {
                    errorMessage = 'You do not have access to perform this action.';
                } else {
                    errorMessage = data.responseJSON.errors;
                }
                // eslint-disable-next-line no-new, new-cap
                new PNotify.error({
                    title: 'Error Granting Role Permissions',
                    text: errorMessage,
                    icon: 'fa fa-exclamation-triangle',
                    type: 'error',
                });
            },
            complete() {
                document.body.style.cursor = 'default';
            },
        });
    };

    const grantOrRevokeAll = (route) => {
        const select = document.getElementById('user-roles-dropdown');
        const roleId = select.options[select.selectedIndex].value;

        if (roleId === 'default') {
            // eslint-disable-next-line no-new, new-cap
            new PNotify.error({
                title: 'Error Granting Role Permissions',
                text: 'Please Select a User Role',
                icon: 'fa fa-exclamation-triangle',
                type: 'error',
            });
        } else {
            document.body.style.cursor = 'wait';
            $.ajax({
                url: Slim.Router.pathFor(`user_management.permissions.${route}`),
                type: 'POST',
                data: {
                    role_id: roleId,
                },
                success(respone) {
                    if (route === 'grantAll') {
                        respone.forEach((d) => {
                            roleData[roleId].permissions = {
                                ...roleData[roleId].permissions,
                                [d.permission_id]: d.name,
                            };
                        });
                    } else {
                        respone.forEach((d) => {
                            delete roleData[roleId].permissions[d.permission_id];
                        });
                    }
                    $table.bootstrapTable('selectPage', $('#permissions-table').bootstrapTable('getOptions').pageNumber);
                },
                error(data) {
                    let errorMessage = '';
                    if (data.status < 400) {
                        errorMessage = 'You do not have access to perform this action.';
                    } else {
                        errorMessage = data.responseJSON.errors;
                    }
                    // eslint-disable-next-line no-new, new-cap
                    new PNotify.error({
                        title: 'Error Granting Role Permissions',
                        text: errorMessage,
                        icon: 'fa fa-exclamation-triangle',
                        type: 'error',
                    });
                },
                complete() {
                    document.body.style.cursor = 'default';
                },
            });
        }
    };

    return {
        init,
    };
}());
